import { useMemo, useRef } from "react";
import { findWhere } from "underscore";

import Constants from "utils/Constants";
import FieldUtils from "utils/FieldUtils";
import { countKeys } from "utils/GeneralUtils";

const complexFieldDef = Constants.COMPLEX_FIELDS;
const complexFieldMap = Constants.COMPLEX_FIELDS_MAP;

const getComplexField = (fieldType, key) => {
  return findWhere(complexFieldDef[fieldType], {
    APIName: key,
  });
};

const useHeadersPickerData = ({ fieldMap, mappedHeaders }) => {
  const numberOfKeys = useMemo(() => countKeys(mappedHeaders), [mappedHeaders]);

  const mappedHeadersRef = useRef();
  mappedHeadersRef.current = mappedHeaders;

  const pickerData = useMemo(() => {
    const mappedHeaders = mappedHeadersRef.current;

    const mappedHeaderKeys = Object.keys(mappedHeaders);

    if (!mappedHeaderKeys.length) return [];

    return Object.keys(mappedHeaders).flatMap((header) => {
      const foundField = fieldMap[header];

      if (mappedHeaders[header]?.Fields?.length > 0) {
        const fieldType = foundField?.FieldType;

        const isSubitem = FieldUtils.fieldTypeIsSubitem(fieldType);
        const isComplex = FieldUtils.isComplex(fieldType);

        const foundFields = [];

        for (let i = 0; i < mappedHeaders[header].Fields.length; i++) {
          const group = mappedHeaders[header].Fields[i];

          for (const key of Object.keys(group.Fields)) {
            const doubleNestedFields = group.Fields[key]?.Fields;

            if (doubleNestedFields) {
              for (let j = 0; j < doubleNestedFields.length; j++) {
                const nestedGroup = doubleNestedFields[j];

                for (const key2 of Object.keys(nestedGroup.Fields)) {
                  const nestedValue = nestedGroup.Fields[key2]?.Identifier;

                  if (!nestedValue) continue;

                  let nestedField = complexFieldMap[key2];

                  if (!nestedField) continue;

                  nestedField = structuredClone(nestedField);
                  nestedField.Name = `${foundField?.Name} ${i + 1} - ${key}  ${
                    j + 1
                  } - ${nestedField?.Name}`;
                  nestedField.APIName = `${foundField?.APIName}_${
                    i + 1
                  }.${key}_${j + 1}.${nestedField?.APIName}`;

                  foundFields.push(nestedField);
                }
              }
            }

            const nestedValue = group.Fields[key]?.Identifier;

            if (!nestedValue) continue;

            const nestedKey = `${foundField?.APIName}.${key}`;
            let nestedField;

            if (isSubitem) {
              nestedField = fieldMap[nestedKey];
            } else if (isComplex) {
              nestedField = getComplexField(fieldType, key);
            }

            if (!nestedField) continue;

            nestedField = structuredClone(nestedField);
            nestedField.Name = `${foundField?.Name} ${i + 1}'s ${
              nestedField?.Name
            }`;
            nestedField.APIName = `${foundField?.APIName}_${i + 1}.${
              nestedField?.APIName
            }`;

            foundFields.push(nestedField);
          }
        }

        return [foundField, ...foundFields];
      }

      return foundField ? foundField : [];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldMap, numberOfKeys]);

  return pickerData;
};

export default useHeadersPickerData;
